const initResolutionLink = () => {
  const links = document.querySelectorAll("[data-resolution]");
  links.forEach((link) => {
    link.addEventListener("click", () => {
      link.href = link.href.split('?')[0];
    })
  })    
};

export default initResolutionLink;
